// extracted by mini-css-extract-plugin
export default {"input":"Tkxfyy7x"};